import React, { useState, useEffect } from "react";
import { columnsDepositAgent } from "../../internals/data/depositData.js";
import { getDeposits, getDepositsAgent } from "../../actions/deposit.js";
import { DataGrid, Toolbar, ExportCsv, GridToolbarExportContainer } from "@mui/x-data-grid";
import CircularProgress from "@mui/material/CircularProgress";
import { Box, Grid } from "@mui/material";
import { useNavigate } from "react-router";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
	odd: {},
	even: {},
});

const AgentDepositReport = ({ token, id, isAuthenticated, setIsAuthenticated }) => {
	const [rows, setRows] = useState(null);
	const navigate = useNavigate();
	const classes = useStyles();

	useEffect(() => {
		getDepositsAgent(token, id, (res) => {
			if (!res.error) {
				setRows(res.data);
			} else {
				if (res.message.toString().includes("Token Expired")) {
					navigate("/logout");
				}
			}
		});
	}, []);
	return (
		<>
			{rows ? (
				<DataGrid
					checkboxSelection={false}
					rows={rows}
					columns={columnsDepositAgent}
					getRowClassName={(params) => (params.indexRelativeToCurrentPage % 2 === 0 ? classes.even : classes.odd)}
					initialState={{
						pagination: { paginationModel: { pageSize: 20 } },
					}}
					pageSizeOptions={[10, 20, 50]}
					disableColumnResize
					density="compact"
					showToolbar
					slotProps={{
						filterPanel: {
							filterFormProps: {
								logicOperatorInputProps: {
									variant: "outlined",
									size: "small",
								},
								columnInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								operatorInputProps: {
									variant: "outlined",
									size: "small",
									sx: { mt: "auto" },
								},
								valueInputProps: {
									InputComponentProps: {
										variant: "outlined",
										size: "small",
									},
								},
							},
						},
					}}
				/>
			) : (
				<Grid container sx={{ justifyContent: "center", alignContent: "center", textAlign: "center" }}>
					<Box>
						<CircularProgress color="primary" size={80} thickness={5} />
					</Box>
				</Grid>
			)}
		</>
	);
};

export default AgentDepositReport;
